var ImageSlider = function(){

    'use strict';

    var $ = jQuery,
        instances = [],
        $owl = null;

    function onReady() {
        $('.module.image-slider').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id');

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // instance object
        var instance = {
            init: function () {
                $owl = $view.find('.carousel-container.owl-carousel').owlCarousel({
                    slideBy: 1,
                    items: 3,
                    slideSpeed: 1000, 
                    pagination: true, 
                    loop: true,
                    autoplayHoverPause: false,
                    dots: false,
                    autoplay: true,
                    autoplayTimeout: 10000,
                    repeat: true,
                    responsiveClass: true,
                    lazyLoad: true,
                    responsive : {
                        // breakpoint from 0 up
                        0 : {
                            items : 1,
                            slideBy: 1
                        },
                        // breakpoint from 480 up
                        660 : {
                            items : 2,
                            slideBy: 2
                        },
                        // breakpoint from 768 up
                        1024 : {
                            items: 3,
                            slideBy: 3
                        }
                    },
                    onInitialize: showCarrousel
                });
            }
        };

        function showCarrousel() {
            $('.module.image-slider').css('display', 'block');
        }


        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

ImageSlider();
